/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum QuotePlanPriorities {
  COMPANY_COSTS = 'COMPANY_COSTS',
  TOP_BENEFITS = 'TOP_BENEFITS',
  EMPLOYEE_COSTS = 'EMPLOYEE_COSTS',
  COMPLIANCE = 'COMPLIANCE',
  INDUSTRY_STANDARD = 'INDUSTRY_STANDARD',
  SIMILAR_CARE = 'SIMILAR_CARE',
}
